<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row v-for="(s, index) in schedules" :key="index">
          <v-col col="12">
            <v-select
              outlined
              dense
              multiple
              chips
              v-model="s.topics"
              :items="topics"
              item-text="name"
              item-value="id"
              :label="`Topics for ${s.date.format('ddd, MMM DD yyyy')}`"
              @change="planChanged = true"
              clearable
            >
              <template v-slot:selection="data">
                <v-chip
                  outlined
                  :key="data.item.id"
                  class="chip--select-multi ma-4"
                >{{ data.item.name }}</v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="planChanged">
        <v-spacer />
        <v-btn @click="updateSchedulePlan">Update Schedule Plan</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';

export default {
  props: {
    courseSchedules: {
      type: Array,
      required: true
    },
    topics: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      planChanged: false,
      schedules: []
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
    
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    initSchedulePlans() {
      this.schedules = this.courseSchedules.map( cs => {
        const selectedTopicIds = cs['schedule.topicSchedule'].map( ts => ts.topicId );
        return { id: cs.id, date: moment(cs.start), topics: selectedTopicIds};
      })

      console.log(this.schedules)
    },
    updateSchedulePlan() {
      const scheduleToTopics = this.schedules.map( s => { return { courseScheduleId: s.id, topicIds: s.topics } })

      const data = { scheduleToTopics };
      this.$axios.post("/course/link-topic-course-schedule", data).then(() => {
        this.addSuccessMessage("Schedule updated");
        this.planChanged = false;
      });
    }
  },
  mounted() {
    this.initSchedulePlans();
  }
};
</script>

<style>
</style>